import { isUndefined } from '@aloft/toolkit-shared';
import { Button, Flex, Typography } from '@aloft/toolkit-sui';

import { useEditPropertyDetailsModal } from '../../components/EditPropertyDetailsModal/useEditPropertyDetailsModal.tsx';
import { ReferenceViewID, ReferenceViewIDParsed, parseReferenceViewID } from './index.ts';

export const NoData = ({
  text = 'No data available',
  referenceViewID,
  updateMLSInfo = false,
}: {
  text?: string;
  referenceViewID?: ReferenceViewID;
  updateMLSInfo?: boolean;
}) => {
  const parsed = referenceViewID ? parseReferenceViewID(referenceViewID) : undefined;
  const propID = getPropIDIfExists(parsed);
  if (propID === undefined) {
    return (
      <Flex marginLeft="auto" marginRight="auto" marginTop="3rem" flexDirection="column">
        <Typography variant="h2">{text}</Typography>
      </Flex>
    );
  }

  return <MLSNoData text={text} propID={propID} updateMLSInfo={updateMLSInfo} />;
};

const MLSNoData = ({
  text,
  propID,
  updateMLSInfo,
}: {
  text: string;
  propID: string;
  updateMLSInfo: boolean;
}) => {
  const EditPropertyModal = useEditPropertyDetailsModal(
    propID,
    propID === 'subject' ? 'MLSInfoForSubject' : 'MLSInfoForComp',
  );

  return (
    <Flex marginLeft="auto" marginRight="auto" marginTop="3rem" flexDirection="column">
      <Typography variant="h2">{text}</Typography>
      {updateMLSInfo && (
        <Button
          onClick={() => EditPropertyModal.props.openModal()}
          text="Update MLS Listing Info"
        />
      )}
      {EditPropertyModal.modal}
    </Flex>
  );
};

function getPropIDIfExists(parsed: ReferenceViewIDParsed | undefined): string | undefined {
  if (isUndefined(parsed) || parsed === null || !('type' in parsed)) {
    return undefined;
  }

  return parsed.type === 'subject' ? 'subject' : parsed.compID;
}
